'use client';

import { usePathname } from 'next/navigation';

import BottomNav from './BottomNav';

export default function BottomNavWrapper() {
  const pathname = usePathname();

  // Show BottomNav only on top-level pages (baseNavItems + auth pages)
  const topLevelPages = ['/', '/challenges', '/saved', '/leaderboard', '/mypage'];
  // Hide in onboarding routes per UI/UX rule (App Router group '(onboarding)' exposes '/welcome' path)
  if (pathname?.startsWith('/welcome') || pathname?.startsWith('/onboarding')) {
    return null;
  }

  const shouldShowBottomNav = topLevelPages.some(page => pathname === page);

  if (!shouldShowBottomNav) {
    return null;
  }

  return <BottomNav />;
}
